import { contactLegalData } from "../../data/legalRequisites";
import Telegram from "../Home/Telegram";

const eventsData = [
  {
    name: "Телефон",
    value: "+7 (995) 100-38-38",
  },
  {
    name: "График приема звонков",
    value: "ежедневно с 10:00 до 20:00",
  },
  {
    name: "E-mail",
    value: <a href="mailto:events@xbadm.ru">events@xbadm.ru</a>,
  },
];

const secondaryData = [
  {
    title: "Контактная информация",
    subtitle:
      "На сайте размещена полная информация об организации: адрес, номер телефона, реквизиты юридического лица.",
    data: contactLegalData,
  },
];

const Contact = () => {
  return (
    <main className="contact-main pad">
      <h3>Контакты</h3>
      <div className="container">
        <article
          className="contact"
          aria-label="Контакты бадминтонного клуба Химки"
        >
          <ul>
            {eventsData.map((el, id) => (
              <li key={id}>
                <span>{el.name}:</span>
                <strong>{el.value}</strong>
              </li>
            ))}
          </ul>
          <Telegram />
        </article>
        {secondaryData.map((el, id) => (
          <article className="org" key={id}>
            <h6>{el.title}</h6>
            {el.subtitle && <p className="org-subtitle">{el.subtitle}</p>}
            <ul>
              {el.data.map((item, i) => (
                <li key={i}>
                  <span>{item.name}:</span>
                  <strong>{item.value}</strong>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </main>
  );
};

export default Contact;
